import { Button as MantineButton } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";
import CustomLoader from "../CustomLoader/CustomLoader";

export default function CustomButton({
  children,
  loading = false,
  disabled = false,
  justify = "center",
  loadingText = "Loading...",
  loadingTextPosition = "left",
  loaderSize,
  loaderColor = "white",
  size,
  ...props
}) {
  const isDesktop = useIsDesktop();
  const responsiveLoaderSize = loaderSize ?? (isDesktop ? "sm" : "xs");
  const responsiveSize = size ?? (isDesktop ? "md" : "sm");

  return (
    <MantineButton justify={justify} disabled={disabled || loading} size={responsiveSize} {...props}>
      {loading ? (
        <CustomLoader
          type="oval"
          text={loadingText}
          textPosition={loadingTextPosition}
          size={responsiveLoaderSize}
          color={loaderColor}
        />
      ) : (
        children
      )}
    </MantineButton>
  );
}
